import { IconDirectionDown, IconLogOut, IconPeople, IconUserCircle } from 'components/icons';
import { IconNotification } from 'components/icons/IconNotification';
import { useAuthenticationContext } from 'components/providers/authentication-provider';
import { SITE_MAP } from 'globalConstants';
import { FileWithFullUrls } from 'graphql/main/queries';
import { isEqual, map } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';
import queryString from 'query-string';
import { MouseEvent } from 'react';
import NotificationPopover from './notification-popover';

export interface NavigationObject {
  name: string;
  pathname?: string;
  isExternal?: boolean;
  children?: RootNavigationObject[];
}
export interface RootNavigationObject extends NavigationObject {
  isExtra?: boolean;
  children?: ChildNavigationObject[];
}
export interface ChildNavigationObject extends NavigationObject {
  children?: ChildNavigationObject[];
}

const Toolbar = () => {
  const { asPath, pathname, push, reload } = useRouter();
  const { currentUser, clearAuthentication } = useAuthenticationContext();
  const userMenu = [
    {
      name: 'Thông tin cá nhân',
      icon: <IconUserCircle className='h-[24px] w-[24px]' />,
      pathname: `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.SOCIAL_PROFILE}/${currentUser?.id}`,
    },
    {
      name: 'Thông báo',
      icon: <IconNotification className='h-[24px] w-[24px]' />,
      pathname: `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.NOTIFICATION}`,
    },
    {
      name: 'Bạn bè',
      icon: <IconPeople className='h-[24px] w-[24px]' />,
      pathname: `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.FRIEND}`,
    },
  ];

  const signIn = () => {
    if (!isEqual(pathname, `/${SITE_MAP.SIGN_IN.INDEX}`)) {
      push({
        pathname: `/${SITE_MAP.SIGN_IN.INDEX}`,
        query: queryString.stringify({ redirect: asPath }, { encode: false }),
      });
    }
  };
  const signOut = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    clearAuthentication?.();
    reload();
  };

  return (
    <div className='flex items-center space-x-[28px]'>
      {currentUser && <NotificationPopover />}
      <div>
        {currentUser ? (
          <Link
            href={`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.SOCIAL_PROFILE}/${currentUser?.id}`}
            className='group relative flex cursor-pointer items-center space-x-[8px] text-text'
          >
            <div className='h-[32px] w-[32px] overflow-hidden rounded-full'>
              <img
                src={
                  (currentUser.avatar as FileWithFullUrls)?.originalUrl ??
                  '/images/default-avatar.svg'
                }
                alt='avatar'
                loading='lazy'
                className='h-full w-full object-cover'
              />
            </div>
            <span className='max-w-[100px] truncate font-[600]'>{currentUser.fullName}</span>
            <IconDirectionDown className='min-h-[24px] min-w-[24px]' />
            <div className='absolute right-0 top-full flex w-max origin-[top_center] scale-0 opacity-0 transition duration-[200ms] ease-in-out group-hover:scale-100 group-hover:opacity-100'>
              <ul className='mt-[12px] flex w-[200px] flex-col overflow-hidden rounded-[4px] bg-paper py-[4px] shadow-8'>
                {map(userMenu, (userMenuItem, userMenuItemIndex) => (
                  <li key={userMenuItemIndex}>
                    <Link
                      href={userMenuItem.pathname}
                      className='flex w-full items-center space-x-[8px] px-[12px] py-[8px] text-text hover:bg-secondary'
                    >
                      {userMenuItem.icon}
                      <span className='font-[500] whitespace-nowrap'>{userMenuItem?.name}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <button
                    type='button'
                    className='flex w-full items-center space-x-[8px] px-[12px] py-[8px] text-text hover:bg-secondary'
                    onClick={signOut}
                  >
                    <IconLogOut className='h-[24px] w-[24px]' />
                    <span className='font-[500] whitespace-nowrap'>Đăng xuất</span>
                  </button>
                </li>
              </ul>
            </div>
          </Link>
        ) : (
          <div className='flex space-x-[4px] font-[600] text-text'>
            <Link href={`/${SITE_MAP.SIGN_UP.INDEX}`}>
              <span className='whitespace-nowrap'>Đăng ký</span>
            </Link>
            <span>/</span>
            <button type='button' onClick={signIn}>
              <span className='whitespace-nowrap'>Đăng nhập</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
